type Falsy = false | 0 | "" | null | undefined
type NonFalsy<T> = T extends Falsy ? never : T

export function withoutFalsyValues<T>(items: (T | Falsy)[]): NonFalsy<T>[] {
  return items.filter<NonFalsy<T>>((item): item is NonFalsy<T> => !!item)
}
